import {IComponentController, IScope} from "angular";
import {CustomerFilterParametersServiceName} from "../../../utils/names/serviceNames";
import {CustomerFilterParametersService} from "../../service/CustomerFilterParametersService";
import {LoanType} from "../../model/LoanType";
import {CustomerFilter} from "../../../customers/model/CustomerFilter";

interface LoanTypeFilterComponentScope extends IScope {
    allLoanTypes: LoanType[];
    filter: CustomerFilter;
}

export class LoanTypeFilterComponent implements IComponentController {

    public static instance = {
        template: require('./LoanTypeFilterComponent.html'),
        controller: ["$scope", CustomerFilterParametersServiceName, LoanTypeFilterComponent],
        bindings: {
            filter: '='
        }
    };
    private $scope: LoanTypeFilterComponentScope;
    private loanTypeService: CustomerFilterParametersService;
    private filter: CustomerFilter;


    constructor($scope: LoanTypeFilterComponentScope,
                loanTypeService: CustomerFilterParametersService) {
        this.$scope = $scope;
        this.loanTypeService = loanTypeService;
    }

    $onInit(): void {
        this.$scope.allLoanTypes = Object.values(LoanType);
        this.$scope.filter = this.filter;
    }

}